import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { withStyles, makeStyles, useTheme } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import * as actions from '../../../../store/index';

import { Box, Divider, Typography, Grid, Paper, Link, Slide, IconButton, Tooltip } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import Draggable from 'react-draggable';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import CloseIcon from '@material-ui/icons/Close';
import EmailIcon from '@material-ui/icons/Email';
import LanguageIcon from '@material-ui/icons/Language';
import CenterFocusWeakIcon from '@material-ui/icons/CenterFocusWeak';
import TrendingUpIcon from '@material-ui/icons/TrendingUp';

import ManufactureDateSymbol from '../../../../resources/coorporate_images/manufacture_date_symbol.png';
import ManufactureSymbol from '../../../../resources/coorporate_images/manufacture_symbol.png';
import REFSymbol from '../../../../resources/coorporate_images/REF_Symbol.png';
import IFU_icon from '../../../../resources/icons/IFU_icon.png';

import EcRepSymbol from '../../../../resources/coorporate_images/eu_rep.png';
import MDSymbol from '../../../../resources/coorporate_images/MD_symbol.png';
import CESymbol from '../../../../resources/coorporate_images/CE_0297_Mark_Black.png';
import UDISymbol from '../../../../resources/coorporate_images/UDI_symbol.png';

const CONTACT_EMAIL = 'info@b-rayz.ch';
const CONTACT_EMAIL_LABEL = 'info@b-rayZ.ch';
const WEBSITE_URL = 'https://www.b-rayz.ch';
const WEBSITE_LABEL = 'www.b-rayZ.ch';
const IFU_VERSION = '24-MAR-2025';
const MANUFACTURE_DATE = '19.02.2023';
const COMPANY_ADDRESS = ['Wagistrasse 21', 'CH-8952 Schlieren', 'Switzerland'];
const UDI_DESCRIPTION = '(01)Product Identifier (4326)Release Date (8012)Software Version';
const EC_REP_ADDRESS = ['Prinses Margrietplantsoen 33', 'Suite 123', '2595AM The Hague', 'The Netherlands'];

const useStyles = makeStyles((theme) => ({
  infoText: {
    letterSpacing: '0.1rem',
    textTransform: 'uppercase',
    color: theme.palette.texts.secondary,
    whiteSpace: 'pre',
    maxWidth: '250px',
  },

  infoText_link: {
    letterSpacing: '0.1rem',
    textTransform: 'uppercase',
    color: theme.palette.texts.secondary,
    whiteSpace: 'break-spaces',
    '&:hover': {
      textDecoration: 'underline',
    },
  },

  ifuText: {
    letterSpacing: '0.1rem',
    textTransform: 'uppercase',
    color: theme.palette.texts.secondary,
    whiteSpace: 'break-spaces',
    maxWidth: '100%',
  },

  infoIcon: {
    color: theme.palette.secondary.main,
  },

  info_icons: {
    width: '80px',
    height: 'auto',
    marginRight: '10px',
  },

  ce_icon: {
    width: '90px',
    height: 'auto',
    marginLeft: '100%',
  },

  symbol_icon: {
    width: '70px',
    height: 'auto',
  },

  infoTexts: {
    fontSize: '0.8rem',
    color: 'rgb(204, 204, 204)',
    whiteSpace: 'pre-line',
    margin: '4%',
  },

  qualityInfoText: {
    width: '100%',
    letterSpacing: '0.1rem',
    textTransform: 'uppercase',
    color: theme.palette.texts.secondary,
    whiteSpace: 'pre-line',
  },

  icon_container: {
    display: 'flex',
    alignItems: 'center',
  },

  infoRow: {
    padding: '10px',
  },

  versionRow: {
    margin: 0,
  },

  refIcon: {
    width: '50px',
    marginRight: '4px',
  },

  ifuRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    cursor: 'pointer',
    flexDirection: 'row',
    flexWrap: 'nowrap',
  },

  ifuButton: {
    padding: '5px',
    marginRight: '6px',
  },

  ifuIcon: {
    width: '50px',
  },

  inlineAction: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
  },

  medicalMarks: {
    width: '25%',
    display: 'flex',
    alignItems: 'center',
    margin: '20px 0',
  },

  udiContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    flexDirection: 'column',
  },

  udiText: {
    margin: '2%',
    letterSpacing: '0.1rem',
    fontSize: '0.8rem',
    whiteSpace: 'nowrap',
  },

  udiDescription: {
    margin: '2%',
    letterSpacing: '0.1rem',
    fontSize: '0.8rem',
    whiteSpace: 'pre-wrap',
  },

  regulatoryRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    width: '100%',
    margin: '20px 0',
  },

  clientInfo: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-start',
    margin: '20px 0 10px 0',
    borderTop: '1px solid #808080',
    alignItems: 'center',
  },

  clientInfoText: {
    margin: '20px 0 0 8px',
  },

  nowrap: {
    whiteSpace: 'nowrap',
  },
}));

const styles = (theme) => ({
  draggableTitle: {
    cursor: 'move',
    margin: 0,
    letterSpacing: '2.1rem',
    textTransform: 'uppercase',
    color: theme.palette.primary.main,
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.primary.main,
    transform: 'scale(1.1)',
  },
  title: {
    letterSpacing: '0.2rem',
  },
});

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction='right' ref={ref} {...props} />;
});

function PaperComponent(props) {
  return (
    <Draggable handle='#draggable-dialog-title' cancel={'[class*="MuiDialogContent-root"]'}>
      <Paper {...props} />
    </Draggable>
  );
}

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle className={classes.draggableTitle} disableTypography {...other}>
      <Typography className={classes.title} variant='h5'>
        {children}
      </Typography>
      {onClose ? (
        <IconButton aria-label='close' className={classes.closeButton} onClick={onClose} id='dialog-close'>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

function FilteredImage({ alt, className, filter, src, style }) {
  return <img alt={alt} className={className} src={src} style={{ filter, ...style }} />;
}

function InfoRow({ children, classes, icon: Icon, iconHref, iconLinkProps = {} }) {
  const icon = <Icon className={classes.infoIcon} />;

  return (
    <Grid container direction='row' spacing={1} alignItems='center' className={classes.infoRow}>
      <Grid item xs={1} className={classes.icon_container}>
        {iconHref ? (
          <Link href={iconHref} {...iconLinkProps}>
            {icon}
          </Link>
        ) : (
          icon
        )}
      </Grid>
      <Grid item xs={11}>
        {children}
      </Grid>
    </Grid>
  );
}

function LinkInfoRow({ classes, href, icon, label, linkProps = {} }) {
  return (
    <InfoRow classes={classes} icon={icon} iconHref={href} iconLinkProps={linkProps}>
      <Typography>
        <Link className={classes.infoText} href={href} {...linkProps}>
          {label}
        </Link>
      </Typography>
    </InfoRow>
  );
}

function TextInfoRow({ classes, icon, text }) {
  return (
    <InfoRow classes={classes} icon={icon}>
      <Typography className={classes.qualityInfoText}>{text}</Typography>
    </InfoRow>
  );
}

function TooltipAction({ children, classes, onClick, title }) {
  return (
    <Tooltip arrow placement='right-start' title={<Typography>{title}</Typography>} style={{ zIndex: 2000 }}>
      <div className={classes.inlineAction} onClick={onClick}>
        {children}
      </div>
    </Tooltip>
  );
}

function SoftwareVersionRow({ classes, darkState, onClick, releaseNotesTitle, softwareVersion }) {
  return (
    <Grid
      container
      direction='row'
      spacing={1}
      alignItems='center'
      wrap='wrap'
      className={classes.versionRow}>
      <Grid item>
        <FilteredImage
          src={REFSymbol}
          alt='reference'
          className={classes.refIcon}
          filter={!darkState ? 'invert(80%)' : undefined}
        />
      </Grid>
      <Grid item style={{ cursor: 'pointer' }}>
        <TooltipAction classes={classes} title={releaseNotesTitle} onClick={onClick}>
          <Typography className={classes.infoText_link}>{softwareVersion}</Typography>
        </TooltipAction>
      </Grid>
    </Grid>
  );
}

function IfuVersionRow({ classes, darkState, ifuLabel, onClick }) {
  return (
    <Grid container className={classes.ifuRow}>
      <TooltipAction classes={classes} title='eIFU' onClick={onClick}>
        <IconButton aria-label='eifu' color='secondary' className={classes.ifuButton}>
          <FilteredImage
            src={IFU_icon}
            alt='e-ifu'
            className={classes.ifuIcon}
            filter={!darkState ? 'invert(40%)' : undefined}
          />
        </IconButton>

        <Link className={classes.infoText_link} component='span'>
          <Typography className={classes.ifuText}>{ifuLabel}</Typography>
        </Link>
      </TooltipAction>
    </Grid>
  );
}

function MedicalMarks({ classes, filter }) {
  return (
    <Box p={0} className={classes.medicalMarks}>
      <FilteredImage className={classes.info_icons} src={MDSymbol} alt='medical_device' filter={filter} />
      <FilteredImage className={classes.ce_icon} src={CESymbol} alt='ce_symbol' filter={filter} />
    </Box>
  );
}

function UdiSection({ classes, darkState, filter, udi }) {
  return (
    <Box p={0} className={classes.udiContainer}>
      <FilteredImage className={classes.symbol_icon} src={UDISymbol} alt='udi' filter={filter} />
      <Typography className={classes.udiText} style={{ color: darkState ? '#ccc' : '#575757' }}>
        {udi}
      </Typography>
      <Typography className={classes.udiDescription} style={{ color: darkState ? '#898989' : '#3d3d3d' }}>
        {UDI_DESCRIPTION}
      </Typography>
    </Box>
  );
}

function InfoText({ children, classes, color, className = '' }) {
  return (
    <Typography className={`${classes.infoTexts} ${className}`} style={{ color }}>
      {children}
    </Typography>
  );
}

function RegulatoryInfoBlock({ children, classes, filter, iconAlt, iconSrc, style }) {
  return (
    <Box p={0} className={classes.regulatoryRow} style={style}>
      <FilteredImage className={classes.info_icons} src={iconSrc} alt={iconAlt} filter={filter} />
      <div>{children}</div>
    </Box>
  );
}

function AddressLines({ lines }) {
  return lines.map((line, index) => (
    <React.Fragment key={line}>
      {line}
      {index < lines.length - 1 && <br />}
    </React.Fragment>
  ));
}

export default function Info({ setShowChangeLog }) {
  const classes = useStyles();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const theme = useTheme();
  const globalSettings = useSelector((store) => store.global_settings ?? {});
  const { darkState, activeDialog } = useSelector((store) => store.gui);

  const { quality_system, quality_values = [] } = globalSettings.quality_system ?? {};
  const softwareVersion = process.env.REACT_APP_SOFTWARE_VERSION ?? 'version unknown';
  const udi = process.env.REACT_APP_UDI ?? 'UDI unknown';
  const { client_id, client } = globalSettings;
  const clientName = client?.replace(/[-_/]/g, ' ');
  const symbolFilter = darkState ? 'invert(80%)' : 'invert(40%)';
  const infoColor = darkState ? '#ccc' : '#575757';

  const closeDialog = () => dispatch(actions.setActiveDialog(null));
  const openIfuDialog = () => dispatch(actions.setActiveDialog('ifu_language'));

  const contactRows = [
    {
      icon: EmailIcon,
      href: `mailto:${CONTACT_EMAIL}`,
      label: CONTACT_EMAIL_LABEL,
    },
    {
      icon: LanguageIcon,
      href: WEBSITE_URL,
      label: WEBSITE_LABEL,
      linkProps: { target: '_blank', rel: 'noopener noreferrer' },
    },
  ];

  const qualityRows = [
    {
      id: 'quality-system',
      icon: CenterFocusWeakIcon,
      text: `${t('information.quality_system')}: ${quality_system?.toUpperCase() ?? ''}`,
    },
    {
      id: 'quality-values',
      icon: TrendingUpIcon,
      text: `${t('information.quality_values')}:  ${quality_values.join(', ')}`,
    },
  ];

  return (
    <Dialog
      TransitionComponent={Transition}
      keepMounted
      PaperComponent={PaperComponent}
      aria-labelledby='draggable-dialog-title'
      onClose={closeDialog}
      open={activeDialog === 'info'}
      fullWidth
      maxWidth='lg'
      style={{ zIndex: theme.zIndex.main_drawer }}>
      <DialogTitle id='draggable-dialog-title' onClose={closeDialog} style={{ textTransform: 'none' }}>
        b-box plus (DANAI)
      </DialogTitle>
      <Divider />

      <DialogContent>
        <Grid container direction='row' wrap='nowrap' justifyContent='flex-start' spacing={1}>
          <Grid
            xs={6}
            item
            container
            direction='column'
            alignItems='flex-start'
            justifyContent='space-evenly'>
            {contactRows.map((row) => (
              <LinkInfoRow key={row.href} classes={classes} {...row} />
            ))}

            {qualityRows.map((row) => (
              <TextInfoRow key={row.id} classes={classes} {...row} />
            ))}

            <SoftwareVersionRow
              classes={classes}
              darkState={darkState}
              releaseNotesTitle={t('Layout.release_notes')}
              softwareVersion={softwareVersion}
              onClick={() => setShowChangeLog?.(true)}
            />

            <IfuVersionRow
              classes={classes}
              darkState={darkState}
              ifuLabel={`${t('information.ifu_version')}: ${IFU_VERSION}`}
              onClick={openIfuDialog}
            />

            <MedicalMarks classes={classes} filter={symbolFilter} />
          </Grid>

          <Grid xs={6} item>
            <UdiSection classes={classes} darkState={darkState} filter={symbolFilter} udi={udi} />

            <RegulatoryInfoBlock
              classes={classes}
              iconSrc={ManufactureSymbol}
              iconAlt='manufacture'
              filter={symbolFilter}>
              <InfoText classes={classes} color={infoColor}>
                b-rayZ AG
              </InfoText>
              <InfoText classes={classes} color={infoColor}>
                <AddressLines lines={COMPANY_ADDRESS} />
              </InfoText>
            </RegulatoryInfoBlock>

            <RegulatoryInfoBlock
              classes={classes}
              iconSrc={ManufactureDateSymbol}
              iconAlt='manufacture_date'
              filter={symbolFilter}>
              <InfoText classes={classes} color={infoColor}>
                {MANUFACTURE_DATE}
              </InfoText>
            </RegulatoryInfoBlock>

            <RegulatoryInfoBlock
              classes={classes}
              iconSrc={EcRepSymbol}
              iconAlt='ecrep'
              filter={symbolFilter}
              style={{ margin: '20px 0 0' }}>
              <InfoText classes={classes} color={infoColor}>
                MedEnvoy Global B.V.
              </InfoText>
              <InfoText classes={classes} color={infoColor} className={classes.nowrap}>
                <AddressLines lines={EC_REP_ADDRESS} />
              </InfoText>
            </RegulatoryInfoBlock>
          </Grid>
        </Grid>

        <div className={classes.clientInfo}>
          <Typography className={`${classes.infoText} ${classes.clientInfoText}`}>
            {clientName || ''} - {client_id || ''}
          </Typography>
        </div>
      </DialogContent>
    </Dialog>
  );
}
